import React, { Component } from 'react'
import { connect } from 'react-redux'
import Header from '../header/header'
import PropTypes from 'prop-types';
import { homeColor } from '../../JS/colorConfig'
import { setWebViewAfterKeyBoard } from "../../../JS/setWebView"
import $ from 'jquery'
import {
    setRegPage, setLoadingMass, setGuestLogin,
    validateGuestdetail, popupOpenClose,
    setDeviceLoginPage, currentWidget, setDeviceConfigFailed, setPreloadScreen
} from '../../../action/action'
import { fetchSessionToken } from '../../../JS/fetchSessionToken'
import { setGoHome, setRedirectInfo } from '../../action/homeAction'
import { LOGINENABLED, PRIVACYPOLICY, TERMSANDCONDITIONS } from '../../../config/constant';
import { inAppBrowser } from '../../JS/inAppBrowser';
import { withTranslation } from "react-i18next";
import SelectLanguageDropdown from '../../UI/selectLanguageDropdown';
import { sendAnalytics } from '../../../action/homeAction';

class AppInfoPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasReservationNumberCheck: 'false'
        }
    }

    componentDidMount() {
        homeColor(this.props.menuColor);
        if (!this.props.showPlaceOrder)
            this.props.currentWidget({});

        this.setState({ hasReservationNumberCheck: localStorage.getItem('hasReservationNumberCheck') })
    }

    componentDidUpdate() {
        console.log("$('footer')", $("footer"))
        if (this.props.hideFooter) {
            $("footer").hide()
            $("header").hide()
            $("#place-order-my-order").hide()
        }
    }

    componentWillUnmount() {
        console.log("this.props.showPlaceOrder", this.props.showPlaceOrder)
        if (this.props.showPlaceOrder) {
            window.location.hash = "/hcommerce2"
            //    window.location.href = window.location.hash
        }
        if (this.props.hideFooter) {
            $("footer").show()
            $("header").show()
            $("#place-order-my-order").show()
        }
    }


    openLinkHandler = (link, displayName) => {
        if (link) {
            inAppBrowser(link, this.props, false, { displayName: displayName, dontSetCurrentWidget: true })
        }

    }

    render() {
        const { t } = this.props
        return (
            <>
                <section class="overlay">
                    <div class="overlay-window-container">
                        <div class="overlay-window">
                            <div class="overlay-content padding-0">
                                <div class="overlay-header">
                                    <div class="overlay-header-title">
                                        <h2 style={{ color: "#000 !important" }}>App Info</h2>
                                        <div class="row app-version">
                                            <p class="margin-bottom-0" style={{ fontSize: '0.8rem' }}>{`V${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="overlay-controls">
                                <div class="privacy">
                                    {this.props.privacyPolicyUrl && <p style={{ fontWeight: "normal", fontSize: "14px" }} className="w-50 align-left" onClick={() => this.openLinkHandler(this.props.privacyPolicyUrl, "Privacy Policy")}>{t('profile.privacy_policy')}</p>}
                                    {this.props.tncUrl && <p style={{ fontWeight: "normal", fontSize: "14px" }} className="w-50 align-right" onClick={() => this.openLinkHandler(this.props.tncUrl, "Terms & Conditions")}>{t('profile.tnc')}</p>}
                                </div>
                                <div class="row margin-top-2">
                                    <button class="button w-100 margin-top-1 secondary" onClick={() => this.props.setRegPage(false)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}


const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor ? state.store.home.MenuColor : {},
        guestLoginPage: state.store.guestLoginPage,
        currentWidget: state.store.sideNavBar.currentWidget,
        privacyPolicyUrl: state.store.home.privacyPolicyUrl,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        langWidget: state.store.home.langWidget,
        tncUrl: state.store.home.tncUrl,
        redirectInfo: state.store2.redirectInfo,
        currentHomePage: state.store2.currentHomePage,
        showPlaceOrder: state.store2.showPlaceOrder,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        footerTabList: getTabs(state.store.home.currentDuration),
    }
}

const getTabs = (duration) => {
    if (duration && duration.tabDetails && duration.tabDetails.length > 0) {
        return duration.tabDetails
    } else { return false }
}

export default connect(
    mapStateToProps,
    {
        setRegPage,
        setLoadingMass,
        validateGuestdetail,
        popupOpenClose,
        setDeviceLoginPage,
        currentWidget,
        setRedirectInfo,
        setGoHome,
        setGuestLogin,
        setDeviceConfigFailed,
        setPreloadScreen,
        sendAnalytics
    }
)(withTranslation('translations')(AppInfoPage));